import { z } from "zod";
//#region src/const/oauth.ts
const OAuthType = {
	google: "google",
	twitter: "twitter",
	apple: "apple",
	apple2: "apple2",
	discord: "discord"
};
const OAuthTypeEnum = z.enum(OAuthType);
//#endregion
export { OAuthType, OAuthTypeEnum };
